import { serializeGreeting } from 'services/api/greeting/serialization';
import { type IGreeting } from 'store/entities/greetings/interfaces';

export const getGreetingTypeForEvent = (greeting: IGreeting): string =>
  serializeGreeting(greeting).rules[0].type.toString();
